import Swiper from 'swiper';
import { Keyboard, Mousewheel, Navigation, Thumbs } from 'swiper/modules';
import 'swiper/css';

const timelineSlider = document.getElementsByClassName('timeline');
if(timelineSlider) {
	let timelinePagination = new Swiper('.timeline-pagination', {
		modules: [Navigation],
		slidesPerView: 1,
		navigation: {
			prevEl: '.timeline-wrap .swiper-button-prev',
			nextEl: '.timeline-wrap .swiper-button-next',
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
			},
			992: {
				slidesPerView: 3,
			}
		}
	});
	
	new Swiper('.timeline', {
		modules: [Navigation, Thumbs],
		slidesPerView: 1,
		spaceBetween: 24,
		grabCursor: false,
		navigation: {
			prevEl: '.timeline-wrap .swiper-button-prev',
			nextEl: '.timeline-wrap .swiper-button-next',
		},
		thumbs: {
			swiper: timelinePagination,
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
			},
			992: {
				slidesPerView: 3,
			}
		}
	});
}

const baseSwiperConfig = {
	modules: [Keyboard, Mousewheel, Navigation],
	loop: false,
	grabCursor: true,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	slidesPerView: 4,
	spaceBetween: 12,
	keyboard: {
		enabled: true,
		onlyInViewport: false,
	},
	mousewheel: true,
	breakpoints: {
		364: {
			slidesPerView: 5,
		},
		448: {
			slidesPerView: 6,
		},
		576: {
			slidesPerView: 'auto',
		}
	}
};

function getSelectedRadioIndex() {
	const selectedRadio = document.querySelector('.swiper-variations input[name="attribute_image_duplicate"]:checked');

	if(selectedRadio) {
		const swiperWrapper = document.querySelector('.swiper-wrapper');
		const radios = swiperWrapper.querySelectorAll('input[name="attribute_image_duplicate"]');

		return Math.max(0, Array.from(radios).indexOf(selectedRadio) - 1);
	}

	return 0;
}

let swiper = new Swiper('.swiper-variations', {
	...baseSwiperConfig,
	initialSlide: getSelectedRadioIndex(),
});

const toggleSwitch = document.getElementById('toggle-swiper');

if(toggleSwitch) {
	toggleSwitch.addEventListener('change', function() {
		if(this.checked) {
			if(swiper) {
				swiper.destroy(true, true);
				swiper = null;
			}
		} else {
			if(!swiper) {
				swiper = new Swiper('.swiper-variations', {
					...baseSwiperConfig,
					initialSlide: getSelectedRadioIndex(),
				});
			}
		}
	});
}

const radioImageButtons = document.querySelectorAll('.product-variations-image input[name="attribute_image_duplicate"]');
const mainImageA = document.querySelector('.wp-post-image-a');
const mainImage = document.querySelector('.wp-post-image');
const selectImage = document.querySelector('#image');
const figure = document.querySelector('figure.product-image-figure');

if(radioImageButtons && mainImageA && mainImage && figure) {
	const update = (radio) => {
		const newImage = radio.nextElementSibling.querySelector('img');

		if(newImage) {
			mainImageA.setAttribute('href', newImage.getAttribute('src'));

			if(newImage.getAttribute('src').split('.').pop().split('?')[0].split('#')[0] == 'svg') {
				mainImageA.setAttribute('data-pswp-width', 800);
				mainImageA.setAttribute('data-pswp-height', Math.ceil(newImage.getAttribute('height') * 800 / newImage.getAttribute('width')));
			} else {
				mainImageA.setAttribute('data-pswp-width', newImage.getAttribute('width'));
				mainImageA.setAttribute('data-pswp-height', newImage.getAttribute('height'));
			}

			mainImage.setAttribute('src', newImage.getAttribute('src'));

			let figCaption = figure.querySelector('figcaption');

			if(!figCaption) {
				figCaption = document.createElement('figcaption');
				figCaption.className = 'bg-black fw-bold lh-sm product-image-caption px-2 px-lg-3 py-2 text-center text-white';
				figure.appendChild(figCaption);
			}

			figCaption.textContent = newImage.getAttribute('alt');

			selectImage.value = radio.value;
			selectImage.dispatchEvent(new Event('change', {
				bubbles: true
			}));
		}
	};

	radioImageButtons.forEach(function(radio) {
		radio.addEventListener('change', function() {
			update(this);
		});
	});

	const checkedRadioImage = document.querySelector('.product-variations-image input[name="attribute_image_duplicate"]:checked');

	if(checkedRadioImage) {
		update(checkedRadioImage);
	}
}

const radioFormatButtons = document.querySelectorAll('.product-variations-format input[name="attribute_format_duplicate"]');
const selectFormat = document.querySelector('#format') || document.querySelector('#pa_format');

if(radioFormatButtons) {
	const update = (radio) => {
		selectFormat.value = radio.value;
		selectFormat.dispatchEvent(new Event('change', {
			bubbles: true
		}));
	};

	radioFormatButtons.forEach(function(radio) {
		radio.addEventListener('change', function() {
			update(this);
		});
	});

	const checkedRadioFormat = document.querySelector('.product-variations-format input[name="attribute_format_duplicate"]:checked');

	if(checkedRadioFormat) {
		update(checkedRadioFormat);
	}
}